import integrationSystemApi from '../api/inegration-system'
async function tagManager(tag, workspaceId, user) {
    const body = { tag, workspaceId, user }
    try {
        const { data: response } = await integrationSystemApi.put("/gupy/change-last-tag", body);
        // console.log("Tag added/changed successfully: ", response)
    } catch (error) {
        //TODO: make a error message showing up instead console.log error
        // console.error("Error trying to add/change Tag: ", error)
    }
}

async function getGupyService(gupyServiceId, userId, serviceName) {
    console.table({ gupyServiceId, userId, serviceName})
    try {
        const { data: gupyService } = await integrationSystemApi.get(`/gupy/gupy-service/${gupyServiceId}`)
        // console.log("gupyService from getGupyService: ", gupyService)
        if (gupyService.document_id != userId || gupyService.test_id != serviceName) return false
        localStorage.setItem("gupyServiceInfo", JSON.stringify(gupyService))
        return gupyService
    } catch (error) {
        //TODO: make a error message showing up instead console.log error
        // console.error("Error trying to verify Gupy Service: ", error)
        return false
    }
}

async function verifyKenobyInfo(kenobyInfoId, workspaceExternalId, userId){
    try {
        const { data: response } = await integrationSystemApi.get(`/kenoby/kenoby-info/${kenobyInfoId}`)
        const kenobyInfo = response
        // console.log("kenobyInfo: ", kenobyInfo)
        if (userId != response.applicant || workspaceExternalId != response.position) return false
        return kenobyInfo
    } catch (error) {
        //TODO: make a error message showing up instead console.log error
        // console.error("error trying to get Kenoby Info", error.response)
        return false
    }
}

async function sendKenobyResult(kenobyInfoId, teamGameId, workspaceId, userId){
    try {
        const { data: response } = await integrationSystemApi.post(`/kenoby/send-postponed-result`, { kenobyInfoId, teamGameId, workspaceId, userId })
        // console.log("kenoby send result", response)
        return true
    } catch (error) {
        //TODO: make a error message showing up instead console.log error
        // console.error("error trying to send Kenoby result", error.response)
        return false
    }
}

export { tagManager, getGupyService, verifyKenobyInfo, sendKenobyResult };